// TypesClients.js
import React from "react";
import TierTypes from "./TierTypes";

const TypesClients = () => {
    return <TierTypes title="Types de Clients" category={0} />;
};

export default TypesClients;
